export default {
  defaultCellPadding: '24px',
};
